<template>
  <div id="Checker" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">V</span>isor Precio</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt10 pb10 pl20 pr20 color-muted">
      Se utiliza para generar el código QR del archivo de configuración.
    </div>
    <div class="col-12 t-c">
      <i class="iconfont icon-erweima color-primary f60" v-if="!qrcode1"></i>
      <img v-bind:src="qrcode1" v-else>
    </div>
    <div class="col-12 mt8 pl8 pr8">
      <div class="col-12 bg-color-white f14 pl8 pr8 lh40">
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Versión</div>
          <div class="col-8 t-r">
            <select name="" v-model="pageData.version">
              <option value="3">3.0.3</option>
              <option value="1">1.0.2</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt8 pl8 pr8">
      <div class="col-12 bg-color-white f14 pl8 pr8 lh40">
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">IP del Principal</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.api_url_ip" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">IP de recursos</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.image_url_ip" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Tiempo de Visualización(ms)</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.wait_time" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Estilo de Aparición</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.skin" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-2 t-l color-muted">Idioma</div>
          <div class="col-10 t-r"><input type="text" name="" v-model="pageData.language" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Divisa</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.foreign_currency" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Fuente Bs</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.font_1" class="t-r"></div>
        </div>
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Fuente Divisa</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.font_2" class="t-r"></div>
        </div>
        <!-- 支持的系统选择 -->
        <div class="col-12 bb1">
          <div class="col-4 t-l color-muted">Sistema soportado</div>
          <div class="col-8 t-r">
            <select v-model="pageData.system">
              <option value="1sistema">1sistema</option>
              <option value="hipos">hipos</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12 mb10 mt10">
        <button class="bg-color-primary color-white w-100 lh40" @click="save()">Generar</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Checker',
  data () {
    return {
      pageData: {
        "api_url_ip":"192.168.0.11",
        "image_url_ip":"192.168.0.11",
        "wait_time":"10000",
        "skin":1,
        "language":"es",
        "foreign_currency":1,
        'font_1': 'f46',
        'font_2': 'f30',
        'version': '3',
        'system': '1sistema'
      },
      qrcode1: '',
      qrcode2: ''
    }
  },
  created: function () {
    //this.get_pageData();
  },
  methods: {
    save: function () {
      let postData = {}
      let data = this.pageData;
      data.api_url = 'http://' + this.pageData.api_url_ip + ':8876/viewer/product_find_barcode';
      data.image_url = 'http://' + this.pageData.image_url_ip + '/pose/';
      postData.data = JSON.stringify(this.pageData);
      this.post(this.api_url + 'Tec/qrcode_make',postData, true).then((res)=>{
        if(res.status == 1){
          this.qrcode1 = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Fun/Checker.vue